export function roundNumber(num, decimalPlaces: number) {
  const modifier = 10 ** Math.trunc(decimalPlaces);
  return Math.round((num + Number.EPSILON) * modifier) / modifier;
}
